<template>
  <div>
    <vetster-day-picker
      :date="inputs.date_from"
      :timezone="inputs.timezone"
      :old-date="dates.old_date_from"
      :is-filter="isFilter"
      @update="handleDay"
      @selected="$emit('date-selected')"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import VetsterDayPicker from '@/components/VetsterDayPicker';

export default {
  name: 'VetsterSearchDayPicker',

  components: { VetsterDayPicker },

  props: {
    isFilter: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState('search', [
      'dates',
      'inputs',
    ]),
  },

  methods: {
    handleDay(date) {
      this.$store.commit('search/setDates', { date_from: date });
      this.$store.commit('search/setInputs', { date_from: date });
    },
  },
};
</script>
